/**
 * Only official routes with reviews have the sticky section nav, so its code
 * loads on demand.
 */
export function RoutesShowView() {
  const nav = document.querySelector<HTMLElement>('[data-section-nav]')

  if (!nav) {
    return
  }

  void import('../lib/sectionNav').then(function initNav(sectionNav) {
    sectionNav.initSectionNav(nav)
  })
}
